import React, { ImgHTMLAttributes } from 'react'

import { cn } from './utils/cn'

import ErrorToastIcon from '../img/icons/error-toast.svg'
import InfoToastIcon from '../img/icons/info-toast.svg'
import SuccessToastIcon from '../img/icons/success-toast.svg'
import WarningToastIcon from '../img/icons/warning-toast.svg'

interface AlertProps {
  type: 'error' | 'warning' | 'info' | 'success'
  disableClose?: boolean
  hideIcon?: boolean
  className?: string
}

const handleSource = (type: AlertProps['type']) => {
  switch (type) {
    case 'error':
      return ErrorToastIcon
    case 'warning':
      return WarningToastIcon
    case 'info':
      return InfoToastIcon
    case 'success':
      return SuccessToastIcon
    default:
      return InfoToastIcon
  }
}

const handleColorClasses = (type: AlertProps['type']) => {
  switch (type) {
    case 'error':
      return 'bg-[#F5BABA] border-[#E64B37]'
    case 'warning':
      return 'bg-[#FFF7D3] border-[#FFD000]'
    case 'info':
      return 'bg-[#E3F0F9] border-[#4F7D9C]'
    case 'success':
      return 'bg-[#5AAD75] border-[#C7E3D0]'
    default:
      return
  }
}

const Icon: React.FC<ImgHTMLAttributes<HTMLElement>> = (props) => {
  return <img {...props} className="h-6 w-6 mr-3.5" alt={props.alt} />
}

export const Alert: React.FC<AlertProps> = ({
  type,
  disableClose,
  hideIcon,
  children,
  className,
}) => {
  const [isOpen, setIsOpen] = React.useState(true)

  return (
    <div
      className={cn(
        'flex flex-row p-3.5 border-2 rounded-lg items-center font-gotham',
        !isOpen && 'hidden',
        handleColorClasses(type),
        className,
      )}
    >
      {!hideIcon && <Icon src={handleSource(type)} alt={`${type} icon`} />}
      <div className="w-full">{children}</div>
      {!disableClose && (
        <button onClick={() => setIsOpen(!isOpen)} className="ml-auto p-2 bg-transparent text-xl">
          &times;
        </button>
      )}
    </div>
  )
}
